import { defineStore } from 'pinia';
import { store } from '/@/store';
import { WebSocketClient } from '/@/utils/lib/websocket';
import { useMessage } from '/@/hooks/web/useMessage';
import { router } from '/@/router';
import { h } from 'vue';
import { useUserStoreWithOut } from './user';
import { Message } from '/@/utils/lib/core';

interface SocketState {
  socket: WebSocketClient | null;
  receiveCb: Array<(data: Message) => void>;
}

const { createMessageNotify } = useMessage();
export const useSocketStore = defineStore({
  id: 'app-socket',
  state: (): SocketState => ({
    socket: null,
    receiveCb: [],
  }),
  getters: {
    getSocket(): WebSocketClient {
      return this.socket as WebSocketClient;
    },
  },
  actions: {
    init() {
      return;
      const host = location.host.match('localhost') ? '192.168.12.186:8998' : location.host;
      const socket = new WebSocketClient(
        `${location.protocol.includes('https') ? 'wss' : 'ws'}://${host}/ws`,
      );
      this.socket = socket;
      socket.connect().then(() => {
        this.login();
        socket!.receive((data) => {
          switch (data.event) {
            case 'needLogin':
              this.login();
              break;
            case 'message':
              this.receiveCb.forEach((cb) => cb(data));
              this.createMessage(data.payload);
              break;
          }
        });
      });
    },
    login() {
      const userStore = useUserStoreWithOut();
      if (userStore.getToken) {
        this.socket!.send({
          event: 'login',
          payload: {
            appId: 4,
            groupId: userStore.getUserInfo.deptId || 'default',
            userId: userStore.getUserInfo.id,
          },
        });
      }
    },
    createMessage(payload: { content: string; type: 10 | 20 | 30 | 40 | 50 }) {
      let url = '';
      switch (payload.type) {
        case 10:
          url = '/messageCenter/notify';
          break;
        case 20:
          // 不会收到消息反馈内容
          break;
        case 30:
          url = '/workbench/index';
          break;
        case 40:
          url = '/workbench/index';
          break;
      }
      if (url) {
        const res = payload.content.match(/\[([^}]+)\]/g);
        if (res) {
          res.forEach((i) => {
            payload.content = payload.content.replace(i, `<span class="primary-color">${i}</span>`);
          });
        }
        createMessageNotify({
          description: h('div', {
            innerHTML: payload.content,
          }),
          click: () => {
            router.push(url);
          },
        });
      }
    },
    receive(cb: (data: Message) => void) {
      this.receiveCb.push(cb);
    },
  },
});

// Need to be used outside the setup
export function useSocketStoreWithOut() {
  return useSocketStore(store);
}
